/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import '../All CSS/LoginForm.css';
import Image1 from '../All images/VendorPortal-1.jpeg';
import Image2 from '../All images/VendorPortal-2.jpeg';
import Image3 from '../All images/VendorPortal-3.jpeg';
import { FaEye, FaEyeSlash } from 'react-icons/fa';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const images = [Image1, Image2, Image3]; 

const LoginForm = () => {
  const [clientId, setClientId] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

 // 🔸 Auto image slider
  useEffect(() => {
    if (images.length > 0) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prev) => (prev + 1) % images.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, []);

  // 🔸 Load saved credentials
  useEffect(() => {
    const saved = localStorage.getItem('vendorLogin');
    if (saved) {
      const { clientId: savedClientId, email: savedEmail } = JSON.parse(saved);
      setClientId(savedClientId);
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);

  // 🔸 Handle URL login if params exist
  const urlClientId = searchParams.get('clientId');
  const urlEmail = searchParams.get('email');
  const urlPassword = searchParams.get('password');

  useEffect(() => {
    if (urlClientId && urlEmail && urlPassword) {
      setClientId(urlClientId);
      setEmail(urlEmail);
      setPassword(urlPassword);
      handleLogin(urlEmail, urlPassword, urlClientId);
    }
  }, [urlClientId, urlEmail, urlPassword]);

  // 🔸 Login API
  const handleLogin = async (
    emailParam = email,
    passwordParam = password,
    clientParam = clientId
  ) => {
    setError('');
    if (!clientParam || !emailParam || !passwordParam) {
      setError('All fields are required.');
      return;
    }

    setIsLoading(true);
    try {
      const res = await axios.post(`${API_BASE_URL}/api/vendor-login`, {
        clientId: clientParam,
        email: emailParam,
        password: passwordParam,
        deviceId: ''
      });

      const data = res.data;
      if (data.success && data.RespCode === '0') {
        sessionStorage.setItem('ClientID', clientParam);
        sessionStorage.setItem('UserDetails', JSON.stringify(data.UserDetails));
        sessionStorage.setItem('DatabaseDetails', JSON.stringify(data.DatabaseDetails));

        if (rememberMe) {
          localStorage.setItem('vendorLogin', JSON.stringify({ clientId: clientParam, email: emailParam }));
        } else {
          localStorage.removeItem('vendorLogin');
        }

        navigate('/home');
      } else {
        setError(data.RespMessage || 'Login failed.');
      }
    } catch (err) {
      setError(err.response?.data?.RespMessage || 'Server not reachable.');
    } finally {
      setIsLoading(false);
    }
  };

  // 🔸 Submit
  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!clientId || !email || !password) {
      setError('Please fill in all fields');
      return;
    }
    handleLogin();
  };

  return (
    <div className="Login-form-page">
      {/* Right Section */}
      <div className="Login-from-Right">
        <div className="Image-Container">
          <img
            key={currentImageIndex}
            src={images[currentImageIndex]}
            alt="Vendor Portal"
            className="slider-image"
          />
        </div>
      </div>

      {/* Left Section */}
      <div className="Login-from-Left">
         <div className="Logo-Container">
          <p className="Logo-Container-text">
            <span className="logo-sfactor">S-Factor</span>
            <span className="logo-erp"> ERP</span>
            <span className="logo-version">
              <a href="https://sfactorerp.com/version/3.0" target="_blank" rel="noopener noreferrer">
                Vendor_Portal
              </a>
            </span>
          </p>
        </div>
        <div className="Login-form-container">
          {error && <div className="login-form-error-message">{error}</div>}
          <form onSubmit={handleFormSubmit} className="Login-form">
            <h2 className="Login-form-heading">Login</h2>

            <div className="Login-form-group">
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder=" "
                required
                className="Login-form-group-input"
              />
              <label htmlFor="email" className="Login-form-group-label">Email</label>
            </div>

            <div className="Login-form-group">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder=" "
                required
                className="Login-form-group-input"
              />
              <label htmlFor="password" className="Login-form-group-label">Password</label>
              <span
                className="password-toggle-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <div className="Login-form-group">
              <input
                type="text"
                id="clientId"
                value={clientId}
                onChange={(e) => setClientId(e.target.value)}
                placeholder=" "
                className="Login-form-group-input"
                required
              />
              <label htmlFor="clientId" className="Login-form-group-label">Client ID</label>
            </div>

            <div className="Login-form-options">
              <div className="remember-me">
                <input
                  type="checkbox"
                  id="rememberMe"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <label htmlFor="rememberMe">Remember Me</label>
              </div>

              <span
                className="forgot-password-link"
                onClick={() => navigate('/forgot-password')}
              >
                Forgot Password?
              </span>
            </div>

            <div className="Login-form-footer">
              <button type="submit" className="Login-form-submit-button" disabled={isLoading}>
                {isLoading ? 'Logging in...' : 'Login'}
              </button>
            </div>
          </form>
        </div>

       

        <div className="Company-Link-Container">
          <a href="https://superinfolabs.com/" target="_blank" rel="noopener noreferrer">
            Powered By Super Infolabs Pvt. Ltd.
          </a>
        </div>
      </div>

    </div>
  );
};

export default LoginForm;
